import { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from "react-router";

import { useTypedSelector } from "../../../../../../../store/reducers/use-typed-selector";
import { PATHNAMES } from '../../../../../admin';
import PanelHeader from "../headers/panel-header";
import Structure from "../../structure/structure";
import Icon, { COLORS, ICONS } from "../../../../../../general-ui/icon";
import ModalComponent from '../../../../../../general-ui/modal/modal';
import { AddHomepage } from '../../../../info/info';
import { addWorkingEventHomepage } from '../../../../../../../store/actions/admin/create-event';
import { getHomepageDefaultLanguage } from '../../../../../../../utils/get-language';

export default function LandingPanel(): JSX.Element {
	const {
		workingEvent,
		token
	} = useTypedSelector(state => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		token: state.AuthReducer.token
	}));

	// if we have arrived at this page without a language set, redirect with language
	const { language }: { language?: string; } = useParams();
	const history = useHistory();

	useEffect(() => {
		if (!language) {
			const setLanguage = getHomepageDefaultLanguage();
			history.replace(`${PATHNAMES.Event.LandingLink(workingEvent!.uuid, setLanguage)}`);
		}
	}, [history, language, workingEvent]);

	const [openLandingPageModal, setOpenLandingPageModal] = useState(false);
	const [addLandingPage, setAddLandingPage] = useState(true);
	const dispatch = useDispatch();

	async function handleAddLandingPage() {
		if (addLandingPage) dispatch(addWorkingEventHomepage(workingEvent!.uuid, token!));
		setOpenLandingPageModal(false);
		history.push(PATHNAMES.Event.LandingLink(workingEvent!.uuid));
	}

	function cancelLandingPageModal() {
		setOpenLandingPageModal(false);
		// prevent flashing state
		setTimeout(() => setAddLandingPage(true), 300);
	}

	const closeLandingPageModal = useCallback(() => {
		setOpenLandingPageModal(false);
	}, []);

	return (
		<div className="landing-panel-container">
			<PanelHeader title="Landing" />
			<div className="panel-body">
				{workingEvent?.homepage ? (
					<Structure isLandingPage />
				) : (
					<div className="temp-card">
						<div className="key-gradient"><Icon name={ICONS.DESKTOP_SLIM} color={COLORS.BLACK} size={16} /></div>
						<div>
							<p>Add Landing Page to Customize Landing Page Design</p>
							<button className="no-style add-button" onClick={() => setOpenLandingPageModal(true)}>
								<Icon name={ICONS.ADD} size={16} color={COLORS.CYAN} />
								Add page
							</button>
						</div>
					</div>
				)}
			</div>
			<ModalComponent
				open={openLandingPageModal}
				onRequestClose={closeLandingPageModal}
				title="Add landing page"
				subtitle="A landing page allows you to provide a preview and market your event to guests before they register."
				cancellable={false}
				closeable={false}
				className="add-homepage-modal"
				footer={(
					<>
						<button onClick={cancelLandingPageModal} style={{ marginRight: 16 }}>Cancel</button>
						<button onClick={handleAddLandingPage} className="primary">Add</button>
					</>
				)}
			>
				<AddHomepage addSingleSessionHomepage={addLandingPage} setAddSingleSessionHomepage={setAddLandingPage} />
			</ModalComponent>
		</div>
	);
}